const state = {
  changePasswordModalVisible: false,
};

const mutations = {
  SET_CHANGE_PASSWORD_MODAL_VISIBLE(state, visible) {
    state.changePasswordModalVisible = visible;
  },
};

const actions = {
  showChangePasswordModal({ commit }) {
    commit("SET_CHANGE_PASSWORD_MODAL_VISIBLE", true);
  },

  hideChangePasswordModal({ commit }) {
    commit("SET_CHANGE_PASSWORD_MODAL_VISIBLE", false);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
